module.exports = __webpack_public_path__ + "img/logo_pigma.10bc8b8e.png";